import styles from "../../../../styles/patient-page-modules/readingModal.module.css";
import { formatDate, convertUTCToLocal } from "../../../../utils/helper";

export const bloodGlucoseColumns = [
  {
    key: "reading_dates",
    // SCRUM-968: header click sorts by the timestamp this column shows
    // (no reading has a reading_dates field).
    sortField: "recorded_at",
    label: "Reading Dates",
    alignLeft: true,
    render: (reading) => convertUTCToLocal(reading.recorded_at),
  },
  {
    key: "glucose_level",
    label: "Glucose",
    render: (reading) => (
      <div className={styles.condition}>
        <div
          className={styles.condition_mark}
          style={{
            backgroundColor:
              reading.glucose < 120
                ? "green"
                : reading.glucose < 130
                ? "yellow"
                : "red",
            borderColor:
              reading.glucose < 120
                ? "greenyellow"
                : reading.glucose < 130
                ? "gold"
                : "orange",
          }}
        ></div>{" "}
        {reading.glucose} mg/dl
      </div>
    ),
  },
];
